import React, { Component } from 'react'
import { noop } from 'lodash'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { PopupTooltip, Button, Icon } from '@adc/ui-core'
import { TutorialTooltipGroupContext } from '../util/contexts'
import TutorialTooltipGroupItem from './item'
import TutorialTooltipGroup from './group'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const TOP_CENTER = 'top center'

class TutorialTooltip extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    header: PropTypes.node,
    content: PropTypes.node.isRequired,
    position: PropTypes.string,
    nextButtonContent: PropTypes.node,
    elmId: PropTypes.string,
    fade: PropTypes.bool,
    closeOnDimmerClick: PropTypes.bool,
    childRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  }

  static defaultProps = {
    position: TOP_CENTER,
    closeOnDimmerClick: false,
  }

  static contextType = TutorialTooltipGroupContext

  tooltipHeader = () => (
    <div className={cx('tooltip-header-root', 'u-mb-2')}>
      <div className={cx('tooltip-header')}>{this.props.header}</div>
      <div className={cx('tooltip-close-root')}>
        <Icon
          name='times'
          size='large'
          color='white'
          iconStyle='light'
          data-elm-id={`${this.props.elmId}_tooltip_close_icon`}
          className={cx('tooltip-close-icon')}
          onClick={this.context.handleClose}
        />
      </div>
    </div>
  )

  tooltipContent = () => (
    <>
      <div className={cx('tooltip-content')}>{this.props.content}</div>
      <div className='u-mt-4'>
        <Button
          size='small'
          role='primary'
          className={cx('tooltip-next-button')}
          elmId={`${this.props.elmId}_tooltip_next_button`}
          onClick={this.context.handleNext}
        >
          {this.props.nextButtonContent || 'Next'}
        </Button>
        <span className={cx('tooltip-tutorial-status')}>
          {this.context.tutorialStatus.current} of{' '}
          {this.context.tutorialStatus.total}
        </span>
      </div>
    </>
  )

  render() {
    const { children, position, childRef, elmId, fade, closeOnDimmerClick } =
      this.props
    const { showTooltip, handleClose } = this.context

    return showTooltip ? (
      <PopupTooltip
        open
        pinned
        trigger={
          <div data-elm-id={`${elmId}_tooltip_container`}>
            {fade && (
              <div
                className={cx('dimmer')}
                onClick={closeOnDimmerClick ? handleClose : noop}
              />
            )}
            <div className={cx('show')} ref={childRef}>
              {children}
            </div>
          </div>
        }
        position={position}
        header={this.tooltipHeader}
        content={this.tooltipContent}
        data-elm-id={`${elmId}_tooltip`}
        className={cx('tooltip-root', 'blue-tooltip')}
        wide
      />
    ) : (
      <div ref={childRef}>{children}</div> // Always wraps the component with a div, so this can affect styles
    )
  }
}

export default TutorialTooltip
export { TutorialTooltipGroup, TutorialTooltipGroupItem }
